import React from "react";
import { Modal, Button, Row, Col, Form, InputGroup } from "react-bootstrap";
import { SearchIcon } from "../ui/icons";
import { useAssignTemplatesModal } from "./useAssignTemplatesModal";
import AddEditTemplateModal from "./AddEditTemplateModal";
import "./assignTemplatesModal.scss";

interface Props {
  show: boolean;
  orgId: string | null;
  onClose: () => void;
}

const AssignTemplatesModal = ({ show, orgId, onClose }: Props) => {
  const {
    templates,
    assignedIds,
    search,
    setSearch,
    showAddModal,
    setShowAddModal,
    newTemplate,
    setNewTemplate,
    toggle,
    handleSave,
    handleAddTemplate,
    resetAddForm,
    isBusy,
  } = useAssignTemplatesModal({ show, orgId, onClose });

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="lg"
      className="modal-container"
    >
      <Modal.Header closeButton>
        <Modal.Title>Assign Templates to Organization</Modal.Title>
        <div className="template-assign-add-btn">
          <Button
            className="btn-style"
            onClick={() => setShowAddModal(true)}
          >
            Add Template
          </Button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="template-assign-search">
          <InputGroup>
            <Form.Control
              placeholder="Search template"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <InputGroup.Text>
              <SearchIcon />
            </InputGroup.Text>
          </InputGroup>
        </div>

        <div className="template-assign-grid">
          <Row className="gx-3 gy-3">
            {templates.map((tpl) => (
              <Col xs={12} sm={6} md={4} key={tpl.templateId}>
                <div
                  className={`template-assign-card ${
                    assignedIds.includes(tpl.templateId) ? "selected" : ""
                  }`}
                  onClick={() => toggle(tpl.templateId)}
                >
                  <div className="template-assign-image">
                    {tpl.imageUrl ? (
                      <img src={tpl.imageUrl} alt={tpl.name} />
                    ) : (
                      <span>No image</span>
                    )}
                  </div>
                  <div className="template-assign-label">
                    <div className="name">{tpl.name}</div>
                    <div className="visibility">
                      {tpl.public ? "Public" : "Private"}
                    </div>
                  </div>
                </div>
              </Col>
            ))}
            {templates.length === 0 && (
              <div className="template-assign-empty">No templates found</div>
            )}
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-cancel" onClick={onClose} disabled={isBusy}>
          Cancel
        </Button>
        <Button className="btn-style" onClick={handleSave} disabled={isBusy}>
          Save
        </Button>
      </Modal.Footer>

      <AddEditTemplateModal
        show={showAddModal}
        mode="add"
        form={newTemplate}
        setForm={setNewTemplate}
        isBusy={isBusy}
        onClose={() => {
          setShowAddModal(false);
          resetAddForm();
        }}
        onSubmit={handleAddTemplate}
      />
    </Modal>
  );
};

export default AssignTemplatesModal;
